/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { HiArrowLeft } from 'react-icons/hi';
import { useLocation, useHistory } from 'react-router-dom';

import Button from 'partial/components/Button';
import GenericDetails from 'partial/components/GenericDetails';

const ACL_USER_FORMAT = (x) => [
  {
    label: 'First Name',
    key: 'first_name',
  },
  {
    label: 'Last Name',
    key: 'last_name',
  },
  {
    label: 'Email',
    key: 'email',
  },
  {
    label: 'Status',
    key: (row) => (
      <span
        className={`${
          row?.status === '1' ? 'text-secondary-600' : 'text-danger-600'
        }`}
      >
        {row?.status === '1' ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    label: 'Role',
    key: (row) => (
      <>
        {row?.role ? (
          <span className="capitalize">{row?.role}</span>
        ) : (
          <span>--</span>
        )}
      </>
    ),
  },
  ...(x?.role === 'Biller User'
    ? [
        {
          label: 'Biller Name',
          key: 'biller_name',
        },
      ]
    : []),
  {
    label: 'Last Login',
    key: (row) => {
      if (row?.last_login) return row?.last_login?.replace(/-/g, '/');
      return '-';
    },
  },
];

function ViewAclUser({ data }) {
  const history = useHistory();
  const location = useLocation();

  const initValue = React.useMemo(() => location.state?.initValues || data, [
    location,
    data,
  ]);
  return (
    <div className="flex flex-col">
      <div className="mt-6">
        <Button
          type="button"
          icon={HiArrowLeft}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
      </div>
      <div className="title-h1 p-6 border-b">
        {initValue?.first_name || '---'} {initValue?.last_name || '---'}
      </div>
      <div className="p-6">
        <GenericDetails
          data={initValue}
          format={ACL_USER_FORMAT(initValue)}
          numberOfCols={4}
        />
      </div>
    </div>
  );
}

ViewAclUser.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default ViewAclUser;
